<template>
  <div class="card">
    <div v-if="layout === 'create' && (isProfessor || isAdmin)">
      <div class="card-header" v-html="Translate('@_THESIS')"></div>
      <div class="card-body text-left">
        <form>
          <fieldset>
            <legend v-html="Translate('@_GREEK')"></legend>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="titleEl">
                    <span v-html="Translate('@_UI_THESIS_TITLE')"></span>
                    <span
                      class="ml-1 text-success"
                      v-html="
                        thesis.titleEl.length +
                        '/' +
                        settings.thesis.characterMaxTitleEl
                      "
                      v-bind:class="{
                        'text-danger':
                          thesis.titleEl.length <
                            settings.thesis.characterMinTitleEl ||
                          thesis.titleEl.length >
                            settings.thesis.characterMaxTitleEl,
                      }"
                    ></span>
                  </label>
                  <input
                    type="text"
                    id="titleEl"
                    class="form-control"
                    v-model.trim="thesis.titleEl"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="abstractEl">
                    <span v-html="Translate('@_UI_THESIS_ABSTRACT')"></span>
                    <span
                      class="ml-1 text-success"
                      v-html="
                        thesis.abstractEl.length +
                        '/' +
                        settings.thesis.characterMaxAbstractEl
                      "
                      v-bind:class="{
                        'text-danger':
                          thesis.abstractEl.length <
                            settings.thesis.characterMinAbstractEl ||
                          thesis.abstractEl.length >
                            settings.thesis.characterMaxAbstractEl,
                      }"
                    ></span>
                  </label>
                  <textarea
                    class="form-control"
                    id="abstractEl"
                    rows="5"
                    v-model.trim="thesis.abstractEl"
                  ></textarea>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend v-html="Translate('@_ENGLISH')"></legend>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="titleEn">
                    <span v-html="Translate('@_UI_THESIS_TITLE')"></span>
                    <span
                      class="ml-1 text-success"
                      v-html="
                        thesis.titleEn.length +
                        '/' +
                        settings.thesis.characterMaxTitleEn
                      "
                      v-bind:class="{
                        'text-danger':
                          thesis.titleEn.length <
                            settings.thesis.characterMinTitleEn ||
                          thesis.titleEn.length >
                            settings.thesis.characterMaxTitleEn,
                      }"
                    ></span>
                  </label>
                  <input
                    type="text"
                    id="titleEn"
                    class="form-control"
                    v-model.trim="thesis.titleEn"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="abstractEn">
                    <span v-html="Translate('@_UI_THESIS_ABSTRACT')"></span>
                    <span
                      class="ml-1 text-success"
                      v-html="
                        thesis.abstractEn.length +
                        '/' +
                        settings.thesis.characterMaxAbstractEn
                      "
                      v-bind:class="{
                        'text-danger':
                          thesis.abstractEn.length <
                            settings.thesis.characterMinAbstractEn ||
                          thesis.abstractEn.length >
                            settings.thesis.characterMaxAbstractEn,
                      }"
                    ></span>
                  </label>
                  <textarea
                    class="form-control"
                    id="abstractEn"
                    rows="5"
                    v-model.trim="thesis.abstractEn"
                  ></textarea>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend v-html="Translate('@_OPTIONS')"></legend>
            <div class="form-row">
              <div class="col-3">
                <div class="form-group">
                  <label for="howManyStudentsAllow">
                    <span
                      v-html="
                        Translate('@_UI_THESIS_HOW_MANY_STUDENTS_ALLOWED')
                      "
                    ></span>
                  </label>
                  <select
                    id="howManyStudentsAllow"
                    class="form-control"
                    v-model.trim="thesis.howManyStudentsAllow"
                  >
                    <option
                      v-for="howManyStudentsAllowOption in settings.thesis
                        .howManyStudentsAllow"
                      v-bind:key="howManyStudentsAllowOption"
                      v-bind:value="howManyStudentsAllowOption"
                      v-html="howManyStudentsAllowOption"
                    ></option>
                  </select>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <div class="form-row">
              <div class="col-3">
                <div class="form-group">
                  <label for="thesisType">
                    <span v-html="Translate('@_UI_THESIS_TYPE')"></span>
                  </label>
                  <select
                    id="thesisType"
                    class="form-control"
                    v-model.trim="thesis.typeofthesis"
                    style="width: auto"
                  >
                    <option
                      v-for="thesisTypeOption in settings.thesis.typeofthesis"
                      v-bind:key="thesisTypeOption"
                      v-bind:value="thesisTypeOption"
                      v-html="typeOfThesisText(thesisTypeOption)"
                    ></option>
                  </select>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="card-footer">
        <button
          type="button"
          class="btn btn-info ml-1 mr-1"
          v-html="Translate('@_BACK')"
          v-on:click.prevent="goBack($event)"
        ></button>
        <button
          type="button"
          class="btn btn-primary ml-1 mr-1 ld-ext-right"
          v-on:click.prevent="createThesis($event)"
          v-bind:disabled="!thesisFormIsReady"
        >
          <span v-html="Translate('@_CREATE')"></span>
          <div class="ld spinner-border"></div>
        </button>
      </div>
    </div>
    <div v-if="layout === 'view' && thesis.id > 0">
      <div
        class="card-header"
        v-html="Translate('@_THESIS') + ' ' + thesis.code"
      ></div>
      <div
        class="card-header"
        v-html="
          Translate('@_THESIS_TITLE_STATUS_AND_HOWMANY').replaceArray(
            ['[|STATUS|]', '[|HOWMANY|]'],
            [Translate(thesis.statustext), thesis.howManyStudentsAllow]
          )
        "
      ></div>
      <div class="card-body text-left">
        <form>
          <fieldset disabled v-if="teacher1 !== null">
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="teacher1">
                    <span v-html="Translate('@_THESIS_SUPERVISOR')"></span>
                  </label>
                  <span
                    id="teacher1"
                    class="form-control"
                    v-html="teacher1.name + ' (' + teacher1.email + ')'"
                  ></span>
                </div>
              </div>
            </div>
          </fieldset>
          <p
            class="text-center font-weight-bold"
            v-if="thesis.status == settings.thesis.status.completed"
          >
            Τελικός Βαθμός: {{ this.thesis.totalgrade }}
          </p>
          <br />
          <div
            v-if="
              (thesis.status ==
                settings.thesis.status.pending_for_exam_and_grading ||
                thesis.status == settings.thesis.status.completed) &&
              (isTeacher1 || isAdmin)
            "
          >
            <router-link
              v-bind:to="{ name: 'grade', params: { id: result.id } }"
              class="col-sm btn btn-outline-success float-center"
              tag="button"
              v-html="Translate('@_NOTIFICATION_THESIS_GRADED_TITLE')"
            ></router-link>
          </div>
          <div
            v-if="
              !(
                thesis.status != settings.thesis.status.completed ||
                (!(isStudent && isStudentOfThisThesis) && isStudent)
              )
            "
          >
            <button
              v-for="(student, index) in students"
              v-bind:key="index"
              type="button"
              class="col-sm btn btn-outline-info float-center"
              v-bind:disabled="
                thesis.status != settings.thesis.status.completed ||
                (!(isStudent && isStudentOfThisThesis) && isStudent)
              "
              v-on:click.prevent="
                downloadGrades(student.name, student.am, student.id)
              "
              v-html="
                'Βεβαίωση Εξέτασης: ' +
                student.name +
                ' (' +
                student.am +
                ') - Βαθμός ανα Φοιτητή: ' +
                getGrade(student.id)
              "
            ></button>
          </div>
          <fieldset disabled v-if="this.ui.window.language == 'el'">
            <legend v-html="Translate('@_GREEK')"></legend>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="titleEl">
                    <span v-html="Translate('@_UI_THESIS_TITLE')"></span>
                  </label>
                  <input
                    type="text"
                    id="titleEl"
                    class="form-control"
                    v-model.trim="thesis.titleEl"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="abstractEl">
                    <span v-html="Translate('@_UI_THESIS_ABSTRACT')"></span>
                  </label>
                  <textarea
                    class="form-control"
                    id="abstractEl"
                    rows="5"
                    v-model.trim="thesis.abstractEl"
                  ></textarea>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset disabled v-if="this.ui.window.language == 'en'">
            <legend v-html="Translate('@_ENGLISH')"></legend>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="titleEn">
                    <span v-html="Translate('@_UI_THESIS_TITLE')"></span>
                  </label>
                  <input
                    type="text"
                    id="titleEn"
                    class="form-control"
                    v-model.trim="thesis.titleEn"
                  />
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group">
                  <label for="abstractEn">
                    <span v-html="Translate('@_UI_THESIS_ABSTRACT')"></span>
                  </label>
                  <textarea
                    class="form-control"
                    id="abstractEn"
                    rows="5"
                    v-model.trim="thesis.abstractEn"
                  ></textarea>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset disabled>
            <legend v-html="Translate('@_OPTIONS')"></legend>
            <div class="form-row">
              <div class="col-3">
                <div class="form-group">
                  <label for="howManyStudentsAllow">
                    <span
                      v-html="
                        Translate('@_UI_THESIS_HOW_MANY_STUDENTS_ALLOWED')
                      "
                    ></span>
                  </label>
                  <select
                    id="howManyStudentsAllow"
                    class="form-control"
                    v-model.trim="thesis.howManyStudentsAllow"
                  >
                    <option
                      v-for="howManyStudentsAllowOption in settings.thesis
                        .howManyStudentsAllow"
                      v-bind:key="howManyStudentsAllowOption"
                      v-bind:value="howManyStudentsAllowOption"
                      v-html="howManyStudentsAllowOption"
                    ></option>
                  </select>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset disabled>
            <div class="form-row">
              <div class="col-3">
                <div class="form-group">
                  <label for="thesisType">
                    <span v-html="Translate('@_UI_THESIS_TYPE')"></span>
                  </label>
                  <select
                    id="thesisType"
                    class="form-control"
                    v-model.trim="thesis.typeofthesis"
                    style="width: auto"
                  >
                    <option
                      v-for="thesisTypeOption in settings.thesis.typeofthesis"
                      v-bind:key="thesisTypeOption"
                      v-bind:value="thesisTypeOption"
                      v-html="typeOfThesisText(thesisTypeOption)"
                    ></option>
                  </select>
                </div>
              </div>
            </div>
          </fieldset>

          <div class="row">
            <div class="col-12 text-center">
              <router-link
                type="button"
                class="btn btn-primary"
                v-bind:to="{ name: 'thesis_update', params: { id: thesis.id } }"
                v-html="Translate('@_EDIT')"
                v-if="canUpdateThesis"
              ></router-link>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-12">
            <h4 style="float: left" v-html="Translate('@_THESIS_FILE')"></h4>
            <span
              style="float: left; padding: 4px"
              data-toggle="collapse"
              data-target="#displayinfof"
            >
              <i class="fa fa-info-circle fa-xs"></i>
            </span>
            <div style="clear: both" id="displayinfof" class="collapse">
              <p
                v-html="
                  'O Φοιτητής μπορεί να ανεβάσει αρχείο μόνο στις Καταστάσεις:' +
                  Translate('@_THESIS_STATUS_TAKEN') +
                  ' όσες φορές επιθυμεί.'
                "
              ></p>
              <p
                v-html="
                  'Όταν ζητήσει έγκριση της εργασίας του από τον Επιβλέπων και η Διπλωματική αλλάξει κατάσταση τότε δεν μπορεί να ξανανεβάσει αρχείο.'
                "
              ></p>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div
              class="alert alert-info mb-0"
              role="alert"
              v-html="Translate('@_NO_FILE_FOUND')"
              v-if="!thesis.file"
            ></div>
            <div class="text-center">
              <br/>
              <button
                v-if="thesis.file"
                type="button"
                class="btn btn-outline-info ld-ext-right"
                v-on:click.prevent="downloadThesis($event)"
              >
                <span v-html="Translate('@_DOWNLOAD_FILE')"></span>
                <div class="ld spinner-border"></div>
              </button>

              <button
                v-if="thesis.typeofthesis >= 2 && thesis.fileproposal"
                type="button"
                class="btn btn-outline-info ld-ext-right"
                v-on:click.prevent="downloadThesisProposal($event)"
              >
                <span v-html="Translate('@_DOWNLOAD_FILE_PROPOSAL')"></span>
                <div class="ld spinner-border"></div>
              </button>
                <span
                  v-if="thesis.typeofthesis >= 2 && thesis.fileproposal == null"
                  v-html="'O φοιτητής δεν έχει ανεβάσει Πρόταση'"
                ></span>

              <br/>
                <span
                  v-if="thesis.file == null"
                  v-html="'O φοιτητής δεν έχει ανεβάσει το αρχείο Διπλωματικής/Πτυχιακής'"
                ></span>
              <br/>
              <button
                v-if="
                  (isTeacher1 || isAdmin) & (thesis.lockedfile == 1) &&
                  thesis.status >= settings.thesis.status.taken &&
                  thesis.status <=
                    settings.thesis.status.pending_for_exam_and_grading
                "
                type="button"
                class="btn btn-outline-success ld-ext-right"
                style="height: 25px; margin-top: 10px; padding: 2px"
                v-on:click.prevent="unlockFileThesis(0, $event)"
              >
                <span
                  v-html="'Ξεκλειδώστε για να μπορεί να ξανανεβάσει ο φοιτητής'"
                ></span>
                <div class="ld spinner-border"></div>
              </button>
              <button
                v-if="
                  (isTeacher1 || isAdmin) &&
                  thesis.lockedfile == 0 &&
                  thesis.status >= settings.thesis.status.taken &&
                  thesis.status <=
                    settings.thesis.status.pending_for_exam_and_grading
                "
                type="button"
                class="btn btn-outline-success ld-ext-right"
                style="height: 25px; margin-top: 10px; padding: 2px"
                v-on:click.prevent="unlockFileThesis(1, $event)"
              >
                <span v-html="'Kλειδώστε το ανέβασμα του αρχείου'"></span>
                <div class="ld spinner-border"></div>
              </button>

              <br />
              <br />
              <button
                v-if="
                  (isTeacher1 || isAdmin) &&
                  thesis.status == settings.thesis.status.pending_for_approval
                "
                type="button"
                class="col-sm btn btn-outline-success float-center"
                v-on:click.prevent="approveThesisForExam(thesis.id, 1)"
                v-html="Translate('@_THESIS_ACTION_APPROVE_EXAMS')"
              ></button>
              <button
                v-if="
                  (isTeacher1 || isAdmin) &&
                  thesis.status == settings.thesis.status.pending_for_approval
                "
                type="button"
                class="col-sm btn btn-outline-danger float-center"
                v-on:click.prevent="approveThesisForExam(thesis.id, 2)"
                v-html="Translate('@_THESIS_ACTION_NOT_APPROVE_EXAMS')"
              >
                Δεν εγκρίνω για Εξέταση
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <router-link
              type="button"
              class="btn btn-primary ml-1 mr-1"
              v-bind:to="{
                name: 'thesis_upload_file',
                params: { id: thesis.id },
              }"
              v-html="Translate('@_UPLOAD_FILE') + ' max:25ΜΒ (pdf)'"
              v-if="canUploadFile"
            ></router-link>
            <router-link
              type="button"
              class="btn btn-primary ml-1 mr-1"
              v-bind:to="{
                name: 'thesis_upload_fileproposal',
                params: { id: thesis.id },
              }"
              v-html="Translate('@_UPLOAD_FILE_PROPOSAL') + ' max:2ΜΒ (pdf)'"
              v-if="thesis.typeofthesis >= 2 && canUploadFileProposal"
            ></router-link>
          </div>
          <div class="col-12 text-center">
            <br />
            <button
              type="button"
              class="btn btn-outline-info ml-1 mr-1 ld-ext-right"
              v-on:click.prevent="sendRequestForExamApproval($event)"
              v-if="canRequestApproval"
            >
              <span v-html="Translate('@_THESIS_REQUEST_APPROVAL')"></span>
              <div class="ld spinner-border"></div>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h4
              style="float: left"
              v-html="Translate('@_PREREQUISITE_COURSES')"
            ></h4>
            <span
              v-if="isAdmin || isProfessor"
              style="float: left; padding: 4px"
              data-toggle="collapse"
              data-target="#displayinfoc"
            >
              <i class="fa fa-info-circle fa-xs"></i>
            </span>
            <div style="clear: both" id="displayinfoc" class="collapse">
              <p
                v-if="isAdmin || isProfessor"
                v-html="
                  'O επιβλέπων μπορεί να αλλάξει την λίστα με τα προαπαιτούμενα μαθήματα μόνο στις Καταστάσεις:' +
                  Translate('@_THESIS_STATUS_AVAILABLE')
                "
              ></p>
              <p
                v-if="isAdmin"
                v-html="
                  'O Admin μπορεί να αλλάξει την λίστα με τα προαπαιτούμενα μαθήματα μόνο στις Καταστάσεις:' +
                  Translate('@_THESIS_STATUS_AVAILABLE') +
                  ', ' +
                  Translate('@_THESIS_STATUS_TAKEN') +
                  ', ' +
                  Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL') +
                  ', ' +
                  Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT') +
                  ', ' +
                  Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')
                "
              ></p>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div
              class="alert alert-info mb-0"
              role="alert"
              v-html="Translate('@_NO_PREREQUISITE_COURSES')"
              v-if="courses.length === 0"
            ></div>
            <ul class="list-group" v-if="courses.length > 0">
              <li
                class="list-group-item"
                v-for="(course, index) in courses"
                v-bind:key="index"
              >
                <span v-html="course.code" class="font-weight-bold mr-2"></span>
                <span v-html="course.name" class="mr-2"></span>
                <span
                  v-html="
                    '(' +
                    course.kind +
                    ' - ' +
                    course.semester +
                    ' - ' +
                    course.group +
                    ')'
                  "
                  class="mr-2"
                ></span>
              </li>
            </ul>
          </div>
          <div class="col-12 text-center">
            <router-link
              type="button"
              class="btn btn-primary ml-1 mr-1"
              v-bind:to="{
                name: 'thesis_add_courses',
                params: { id: thesis.id },
              }"
              v-html="Translate('@_ADD_PREREQUISITE_COURSES')"
              v-if="canUpdateThesisCourses"
            ></router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h4
              style="float: left"
              v-html="Translate('@_ASSIGNED_STUDENTS')"
            ></h4>
            <span
              v-if="isAdmin || isProfessor"
              style="float: left; padding: 4px"
              data-toggle="collapse"
              data-target="#displayinfos"
            >
              <i class="fa fa-info-circle fa-xs"></i>
            </span>
            <div style="clear: both" id="displayinfos" class="collapse">
              <p
                v-if="isAdmin || isProfessor"
                v-html="
                  'O επιβλέπων μπορεί να αλλάξει την λίστα με τους συμμετέχοντες φοιτητές μόνο στις Καταστάσεις: ' +
                  Translate('@_THESIS_STATUS_AVAILABLE')
                "
              ></p>
              <p
                v-if="isAdmin"
                v-html="
                  'O Admin μπορεί να αλλάξει την λίστα με τους συμμετέχοντες φοιτητές μόνο στις Καταστάσεις: ' +
                  Translate('@_THESIS_STATUS_AVAILABLE') +
                  ', ' +
                  Translate('@_THESIS_STATUS_TAKEN')
                "
              ></p>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div
              class="alert alert-info mb-0"
              role="alert"
              v-html="Translate('@_NO_STUDENTS_ASSIGNED')"
              v-if="students.length === 0"
            ></div>
            <ul class="list-group" v-if="students.length > 0">
              <li
                class="list-group-item"
                v-for="(student, index) in students"
                v-bind:key="index"
              >
                <span v-html="student.am" class="font-weight-bold mr-2"></span>
                <span v-html="student.name" class="mr-2"></span>
                <span v-html="student.email"></span>
              </li>
            </ul>
          </div>
          <div class="col-12 text-center">
            <router-link
              type="button"
              class="btn btn-primary ml-1 mr-1"
              v-bind:to="{
                name: 'thesis_add_students',
                params: { id: thesis.id },
              }"
              v-html="Translate('@_ADD_STUDENT')"
              v-if="canUpdateThesisStudents"
            ></router-link>
          </div>
        </div>
        <div
          class="row"
          v-if="
            isAdmin ||
            (isProfessor &&
              thesis.status >=
                settings.thesis.status.pending_for_exam_and_grading)
          "
        >
          <div class="col-12">
            <h4
              style="float: left"
              v-html="Translate('@_ASSIGNED_TEACHERS')"
            ></h4>
            <span
              style="float: left; padding: 4px"
              data-toggle="collapse"
              data-target="#displayinfot"
            >
              <i class="fa fa-info-circle fa-xs"></i>
            </span>
            <div style="clear: both" id="displayinfot" class="collapse">
              <p
                v-if="isAdmin || isProfessor"
                v-html="
                  'O επιβλέπων δεν μπορεί να αλλάξει την λίστα με τους Εξεταστές'
                "
              ></p>
              <p
                v-if="isAdmin"
                v-html="
                  'O Admin μπορεί να αλλάξει την λίστα με τους Εξεταστές μόνο στις Καταστάσεις:' +
                  Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT') +
                  ', ' +
                  Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')
                "
              ></p>
            </div>
          </div>
          <div class="col-12 mb-3">
            <div
              class="alert alert-info mb-0"
              role="alert"
              v-html="Translate('@_NO_TEACHERS_ASSIGNED')"
              v-if="teachers.length === 0"
            ></div>
            <ul class="list-group" v-if="teachers.length > 0">
              <li
                class="list-group-item"
                v-for="(teacher, index) in teachers"
                v-bind:key="index"
              >
                <span v-html="teacher.id" class="font-weight-bold mr-2"></span>
                <span v-html="teacher.name" class="mr-2"></span>
                <span v-html="teacher.email"></span>
              </li>
            </ul>
          </div>
          <div class="col-12 text-center">
            <router-link
              type="button"
              class="btn btn-primary ml-1 mr-1"
              v-bind:to="{
                name: 'thesis_add_teachers',
                params: { id: thesis.id },
              }"
              v-html="Translate('@_ADD_TEACHER')"
              v-if="canUpdateThesisTeachers"
            ></router-link>
          </div>
        </div>
      </div>
      <div
        class="card-body text-left"
        v-if="thesis.created_at"
        v-html="'Ημερομηνία Δημιουργίας: ' + thesis.created_at"
      ></div>
      <div
        class="card-body text-left"
        v-if="thesis.contract_date"
        v-html="'Ημερομηνία Ανάληψης: ' + thesis.contract_date"
      ></div>
      <div
        class="card-body text-left"
        v-if="thesis.presentation_date"
        v-html="'Ημερομηνία Παρουσίασης: ' + thesis.presentation_date"
      ></div>
      <div
        class="card-body text-left"
        v-if="thesis.graded_date"
        v-html="'Ημερομηνία Βαθμολογίας: ' + thesis.graded_date"
      ></div>
      <div
        class="card-body text-left"
        v-if="
          thesis.deadline_date &&
          thesis.status <= settings.thesis.status.pending_for_exam_and_grading
        "
        v-html="'Ημερομηνία υλοποίησης, μέχρι: ' + thesis.deadline_date"
      ></div>

      <div class="card-footer">
        <button
          type="button"
          class="btn btn-info ml-1 mr-1"
          v-html="Translate('@_BACK')"
          v-on:click.prevent="goBack($event)"
        ></button>
        <button
          type="button"
          class="btn btn-danger ml-1 mr-1 ld-ext-right"
          v-on:click.prevent="deleteThesis($event)"
          v-if="canDeleteThesis"
        >
          <span v-html="Translate('@_DELETE')"></span>
          <div class="ld spinner-border"></div>
        </button>
      </div>
    </div>
    <div v-if="layout === 'update' && thesis.id > 0">
      <div
        class="card-header"
        v-html="Translate('@_THESIS') + ' ' + thesis.code"
      ></div>
      <div
        class="card-header"
        v-html="
          Translate('@_THESIS_TITLE_STATUS_AND_HOWMANY').replaceArray(
            ['[|STATUS|]', '[|HOWMANY|]'],
            [Translate(thesis.statustext), thesis.howManyStudentsAllow]
          )
        "
      ></div>
      <div v-if="canUpdateThesis">
        <div class="card-body text-left">
          <form>
            <fieldset>
              <legend v-html="Translate('@_GREEK')"></legend>
              <div class="form-row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="titleEl">
                      <span v-html="Translate('@_UI_THESIS_TITLE')"></span>
                      <span
                        class="ml-1 text-success"
                        v-html="
                          thesis.titleEl.length +
                          '/' +
                          settings.thesis.characterMaxTitleEl
                        "
                        v-bind:class="{
                          'text-danger':
                            thesis.titleEl.length <
                              settings.thesis.characterMinTitleEl ||
                            thesis.titleEl.length >
                              settings.thesis.characterMaxTitleEl,
                        }"
                      ></span>
                    </label>
                    <input
                      type="text"
                      id="titleEl"
                      class="form-control"
                      v-model.trim="thesis.titleEl"
                    />
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="abstractEl">
                      <span v-html="Translate('@_UI_THESIS_ABSTRACT')"></span>
                      <span
                        class="ml-1 text-success"
                        v-html="
                          thesis.abstractEl.length +
                          '/' +
                          settings.thesis.characterMaxAbstractEl
                        "
                        v-bind:class="{
                          'text-danger':
                            thesis.abstractEl.length <
                              settings.thesis.characterMinAbstractEl ||
                            thesis.abstractEl.length >
                              settings.thesis.characterMaxAbstractEl,
                        }"
                      ></span>
                    </label>
                    <textarea
                      class="form-control"
                      id="abstractEl"
                      rows="5"
                      v-model.trim="thesis.abstractEl"
                    ></textarea>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend v-html="Translate('@_ENGLISH')"></legend>
              <div class="form-row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="titleEn">
                      <span v-html="Translate('@_UI_THESIS_TITLE')"></span>
                      <span
                        class="ml-1 text-success"
                        v-html="
                          thesis.titleEn.length +
                          '/' +
                          settings.thesis.characterMaxTitleEn
                        "
                        v-bind:class="{
                          'text-danger':
                            thesis.titleEn.length <
                              settings.thesis.characterMinTitleEn ||
                            thesis.titleEn.length >
                              settings.thesis.characterMaxTitleEn,
                        }"
                      ></span>
                    </label>
                    <input
                      type="text"
                      id="titleEn"
                      class="form-control"
                      v-model.trim="thesis.titleEn"
                    />
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="abstractEn">
                      <span v-html="Translate('@_UI_THESIS_ABSTRACT')"></span>
                      <span
                        class="ml-1 text-success"
                        v-html="
                          thesis.abstractEn.length +
                          '/' +
                          settings.thesis.characterMaxAbstractEn
                        "
                        v-bind:class="{
                          'text-danger':
                            thesis.abstractEn.length <
                              settings.thesis.characterMinAbstractEn ||
                            thesis.abstractEn.length >
                              settings.thesis.characterMaxAbstractEn,
                        }"
                      ></span>
                    </label>
                    <textarea
                      class="form-control"
                      id="abstractEn"
                      rows="5"
                      v-model.trim="thesis.abstractEn"
                    ></textarea>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend v-html="Translate('@_OPTIONS')"></legend>
              <div class="form-row">
                <div class="col-3">
                  <div class="form-group">
                    <label for="howManyStudentsAllow">
                      <span
                        v-html="
                          Translate('@_UI_THESIS_HOW_MANY_STUDENTS_ALLOWED')
                        "
                      ></span>
                    </label>
                    <select
                      id="howManyStudentsAllow"
                      class="form-control"
                      v-model.trim="thesis.howManyStudentsAllow"
                    >
                      <option
                        v-for="howManyStudentsAllowOption in settings.thesis
                          .howManyStudentsAllow"
                        v-bind:key="howManyStudentsAllowOption"
                        v-bind:value="howManyStudentsAllowOption"
                        v-html="howManyStudentsAllowOption"
                      ></option>
                    </select>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <div class="form-row">
                <div class="col-3">
                  <div class="form-group">
                    <label for="thesisType">
                      <span v-html="Translate('@_UI_THESIS_TYPE')"></span>
                    </label>
                    <select
                      id="thesisType"
                      class="form-control"
                      v-model.trim="thesis.typeofthesis"
                      style="width: auto"
                    >
                      <option
                        v-for="thesisTypeOption in settings.thesis.typeofthesis"
                        v-bind:key="thesisTypeOption"
                        v-bind:value="thesisTypeOption"
                        v-html="typeOfThesisText(thesisTypeOption)"
                      ></option>
                    </select>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <div class="card-footer">
          <button
            type="button"
            class="btn btn-info ml-1 mr-1"
            v-html="Translate('@_BACK')"
            v-on:click.prevent="goToView(thesis.id, $event)"
          ></button>
          <button
            type="button"
            class="btn btn-primary ml-1 mr-1 ld-ext-right"
            v-on:click.prevent="updateThesis($event)"
            v-bind:disabled="!thesisFormIsReady"
            v-if="canUpdateThesis"
          >
            <span v-html="Translate('@_SAVE')"></span>
            <div class="ld spinner-border"></div>
          </button>
        </div>
        <div class="card-footer">
          <p>Οδηγίες:</p>
          <p
            v-if="isAdmin || isProfessor"
            v-html="
              'O επιβλέπων μπορεί να τροποποιήσει τα παραπάνω πεδία μόνο στις Καταστάσεις:' +
              Translate('@_THESIS_STATUS_AVAILABLE') +
              ', ' +
              Translate('@_THESIS_STATUS_TAKEN')
            "
          ></p>
          <p
            v-if="isAdmin"
            v-html="
              'O Admin μπορεί να τροποποιήσει τα παραπάνω πεδία μόνο στις Καταστάσεις:' +
              Translate('@_THESIS_STATUS_AVAILABLE') +
              ', ' +
              Translate('@_THESIS_STATUS_TAKEN') +
              ', ' +
              Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL') +
              ', ' +
              Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT') +
              ', ' +
              Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')
            "
          ></p>
        </div>
      </div>
    </div>
    <div v-if="layout === 'add_courses' && thesis.id > 0">
      <div
        class="card-header"
        v-html="Translate('@_THESIS') + ' ' + thesis.code"
      ></div>
      <div
        class="card-header"
        v-html="
          Translate('@_THESIS_TITLE_STATUS_AND_HOWMANY').replaceArray(
            ['[|STATUS|]', '[|HOWMANY|]'],
            [Translate(thesis.statustext), thesis.howManyStudentsAllow]
          )
        "
      ></div>
      <div v-if="canUpdateThesisCourses">
        <div class="card-body text-left">
          <courses-search v-on:courseSelected="addCourse"></courses-search>
          <div
            class="alert alert-info mb-0"
            role="alert"
            v-html="Translate('@_NO_PREREQUISITE_COURSES')"
            v-if="courses.length === 0"
          ></div>
          <ul class="list-group" v-if="courses.length > 0">
            <li
              class="list-group-item"
              v-for="(course, index) in courses"
              v-bind:key="index"
            >
              <span v-html="course.code" class="font-weight-bold mr-2"></span>
              <span v-html="course.name" class="mr-2"></span>
              <span
                v-html="
                  '(' +
                  course.kind +
                  ' - ' +
                  course.semester +
                  ' - ' +
                  course.group +
                  ')'
                "
                class="mr-2"
              ></span>
              <button
                type="button"
                class="close float-right"
                v-on:click="removeCourse(index, $event)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </li>
          </ul>
        </div>
        <div class="card-footer">
          <button
            type="button"
            class="btn btn-info ml-1 mr-1"
            v-html="Translate('@_BACK')"
            v-on:click.prevent="goToView(thesis.id, $event)"
          ></button>
          <button
            type="button"
            class="btn btn-primary ml-1 mr-1 ld-ext-right"
            v-on:click.prevent="updateThesisCourses($event)"
            v-bind:disabled="!courseFormIsReady"
            v-if="canUpdateThesisCourses"
          >
            <span v-html="Translate('@_SAVE')"></span>
            <div class="ld spinner-border"></div>
          </button>
        </div>
        <div class="card-footer">
          <p>Οδηγίες:</p>
          <p
            v-if="isAdmin || isProfessor"
            v-html="
              'O επιβλέπων μπορεί να αλλάξει την λίστα με τα προαπαιτούμενα μαθήματα μόνο στις Καταστάσεις:' +
              Translate('@_THESIS_STATUS_AVAILABLE') +
              ', ' +
              Translate('@_THESIS_STATUS_TAKEN') +
              '<p>Μπορείτε να κάνετε Αναζήτηση πληκτρολογώντας >=3 γράμματα</p>'
            "
          ></p>
          <p
            v-if="isAdmin"
            v-html="
              'O Admin μπορεί να αλλάξει την λίστα με τα προαπαιτούμενα μαθήματα μόνο στις Καταστάσεις:' +
              Translate('@_THESIS_STATUS_AVAILABLE') +
              ', ' +
              Translate('@_THESIS_STATUS_TAKEN') +
              ', ' +
              Translate('@_THESIS_STATUS_PENDINGFORAPPROVAL') +
              ', ' +
              Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT') +
              ', ' +
              Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')
            "
          ></p>
        </div>
      </div>
    </div>
    <div v-if="layout === 'add_students' && thesis.id > 0">
      <div
        class="card-header"
        v-html="Translate('@_THESIS') + ' ' + thesis.code"
      ></div>
      <div
        class="card-header"
        v-html="
          Translate('@_THESIS_TITLE_STATUS_AND_HOWMANY').replaceArray(
            ['[|STATUS|]', '[|HOWMANY|]'],
            [Translate(thesis.statustext), thesis.howManyStudentsAllow]
          )
        "
      ></div>
      <div v-if="canUpdateThesisStudents">
        <div class="card-body text-left">
          <users-search
            entity="student"
            v-on:userSelected="addStudent"
          ></users-search>
          <div
            class="alert alert-info mb-0"
            role="alert"
            v-html="Translate('@_NO_STUDENTS_ASSIGNED')"
            v-if="students.length === 0"
          ></div>
          <ul class="list-group" v-if="students.length > 0">
            <li
              class="list-group-item"
              v-for="(student, index) in students"
              v-bind:key="index"
            >
              <span v-html="student.am" class="font-weight-bold mr-2"></span>
              <span v-html="student.name" class="mr-2"></span>
              <span v-html="student.email"></span>
              <button
                type="button"
                class="close float-right"
                v-on:click="removeStudent(index, $event)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </li>
          </ul>
        </div>
        <div class="card-footer">
          <button
            type="button"
            class="btn btn-info ml-1 mr-1"
            v-html="Translate('@_BACK')"
            v-on:click.prevent="goToView(thesis.id, $event)"
          ></button>
          <button
            type="button"
            class="btn btn-primary ml-1 mr-1 ld-ext-right"
            v-on:click.prevent="updateThesisStudents($event)"
            v-bind:disabled="!studentFormIsReady"
            v-if="canUpdateThesisStudents"
          >
            <span v-html="Translate('@_FINALIZE')"></span>
            <div class="ld spinner-border"></div>
          </button>
        </div>
        <div class="card-footer">
          <p>Οδηγίες:</p>
          <p
            v-if="isAdmin || isProfessor"
            v-html="
              'O επιβλέπων μπορεί να αλλάξει την λίστα με τους συμμετέχοντες φοιτητές μόνο στις Καταστάσεις: ' +
              Translate('@_THESIS_STATUS_AVAILABLE')
            "
          ></p>
          <span>Έλεγχος ΔΜ: </span
          ><a
            href="https://www.iee.ihu.gr/ects160/api.php?am=xxxxxx"
            target="_blank"
            >https://www.iee.ihu.gr/ects160/api.php?am=xxxxxx</a
          >
          <p
            v-if="isAdmin"
            v-html="
              'O Admin μπορεί να αλλάξει την λίστα με τους συμμετέχοντες φοιτητές μόνο στις Καταστάσεις: ' +
              Translate('@_THESIS_STATUS_AVAILABLE') +
              ', ' +
              Translate('@_THESIS_STATUS_TAKEN')
            "
          ></p>
        </div>
      </div>
    </div>
    <div v-if="layout === 'add_teachers' && thesis.id > 0">
      <div
        class="card-header"
        v-html="Translate('@_THESIS') + ' ' + thesis.code"
      ></div>
      <div
        class="card-header"
        v-html="
          Translate('@_THESIS_TITLE_STATUS_AND_HOWMANY').replaceArray(
            ['[|STATUS|]', '[|HOWMANY|]'],
            [Translate(thesis.statustext), thesis.howManyStudentsAllow]
          )
        "
      ></div>
      <div v-if="canUpdateThesisTeachers">
        <div class="card-body text-left">
          <users-search
            entity="teacher"
            v-on:userSelected="addTeacher"
          ></users-search>
          <div
            class="alert alert-info mb-0"
            role="alert"
            v-html="Translate('@_NO_TEACHERS_ASSIGNED')"
            v-if="teachers.length === 0"
          ></div>
          <ul class="list-group" v-if="teachers.length > 0">
            <li
              class="list-group-item"
              v-for="(teacher, index) in teachers"
              v-bind:key="index"
            >
              <span v-html="teacher.id" class="font-weight-bold mr-2"></span>
              <span v-html="teacher.name" class="mr-2"></span>
              <span v-html="teacher.email"></span>
              <button
                type="button"
                class="close float-right"
                v-on:click="removeTeacher(index, $event)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </li>
          </ul>
        </div>
        <div class="card-footer">
          <button
            type="button"
            class="btn btn-info ml-1 mr-1"
            v-html="Translate('@_BACK')"
            v-on:click.prevent="goToView(thesis.id, $event)"
          ></button>
          <button
            type="button"
            class="btn btn-primary ml-1 mr-1 ld-ext-right"
            v-on:click.prevent="updateThesisTeachers($event)"
            v-bind:disabled="!teacherFormIsReady"
            v-if="canUpdateThesisTeachers"
          >
            <span v-html="Translate('@_FINALIZE')"></span>
            <div class="ld spinner-border"></div>
          </button>
        </div>
        <div class="card-footer">
          <p>Οδηγίες:</p>
          <p
            v-if="isAdmin"
            v-html="
              'O Admin μπορεί να αλλάξει την λίστα με τους εξεταστές μόνο στις Καταστάσεις:' +
              Translate('@_THESIS_STATUS_APPROVEDANDWAITINGTOPRESENT') +
              ', ' +
              Translate('@_THESIS_STATUS_PENDINGFOREXAMANDGRADING')
            "
          ></p>
        </div>
      </div>
    </div>
    <div v-if="layout === 'upload_file' && thesis.id > 0">
      <div
        class="card-header"
        v-html="Translate('@_THESIS') + ' ' + thesis.code"
      ></div>
      <div
        class="card-header"
        v-html="
          Translate('@_THESIS_TITLE_STATUS_AND_HOWMANY').replaceArray(
            ['[|STATUS|]', '[|HOWMANY|]'],
            [Translate(thesis.statustext), thesis.howManyStudentsAllow]
          )
        "
      ></div>
      <div v-if="canUploadFile">
        <div class="card-body text-left">
          <div class="custom-file mr-2 mb-2">
            <input
              type="file"
              class="custom-file-input"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
            <label
              class="custom-file-label overflow-hidden"
              for="customFile"
              v-html="Translate('@_UPLOAD_FILE')"
              v-if="uploadFile.filename === null"
            ></label>
            <label
              class="custom-file-label overflow-hidden"
              for="customFile"
              v-html="uploadFile.filename"
              v-if="uploadFile.filename !== null"
            ></label>
          </div>
        </div>
        <div class="card-footer">
          <button
            type="button"
            class="btn btn-info ml-1 mr-1"
            v-html="Translate('@_BACK')"
            v-on:click.prevent="goToView(thesis.id, $event)"
          ></button>
          <button
            type="button"
            class="btn btn-primary ml-1 mr-1 ld-ext-right"
            v-on:click.prevent="uploadThesisFile($event)"
            v-bind:disabled="!uploadFileFormIsReady"
            v-if="canUploadFile"
          >
            <span v-html="Translate('@_FINALIZE')"></span>
            <div class="ld spinner-border"></div>
          </button>
        </div>
      </div>
    </div>

        <div v-if="layout === 'upload_file_proposal' && thesis.id > 0">
      <div
        class="card-header"
        v-html="Translate('@_THESIS') + ' ' + thesis.code"
      ></div>
      <div
        class="card-header"
        v-html="
          Translate('@_THESIS_TITLE_STATUS_AND_HOWMANY').replaceArray(
            ['[|STATUS|]', '[|HOWMANY|]'],
            [Translate(thesis.statustext), thesis.howManyStudentsAllow]
          )
        "
      ></div>
      <div v-if="canUploadFileProposal">
        <div class="card-body text-left">
          <div class="custom-file mr-2 mb-2">
            <input
              type="file"
              class="custom-file-input"
              id="file"
              ref="file"
              v-on:change="handleFileUpload()"
            />
            <label
              class="custom-file-label overflow-hidden"
              for="customFile"
              v-html="Translate('@_UPLOAD_FILE')"
              v-if="uploadFile.filename === null"
            ></label>
            <label
              class="custom-file-label overflow-hidden"
              for="customFile"
              v-html="uploadFile.filename"
              v-if="uploadFile.filename !== null"
            ></label>
          </div>
        </div>
        <div class="card-footer">
          <button
            type="button"
            class="btn btn-info ml-1 mr-1"
            v-html="Translate('@_BACK')"
            v-on:click.prevent="goToView(thesis.id, $event)"
          ></button>
          <button
            type="button"
            class="btn btn-primary ml-1 mr-1 ld-ext-right"
            v-on:click.prevent="uploadThesisFileProposal($event)"
            v-bind:disabled="!uploadFileFormIsReady"
            v-if="canUploadFileProposal"
          >
            <span v-html="Translate('@_FINALIZE')"></span>
            <div class="ld spinner-border"></div>
          </button>
        </div>
      </div>
    </div>

    <div
      class="alert alert-info"
      role="alert"
      v-if="isInvalid"
      v-html="'Λάθος στην αναζήτηση Διπλωματικής'"
    ></div>
  </div>
</template>

<script>
import Mixin from "@/helpers/mixin";
import CoursesSearch from "@/components/CoursesSearch";
import UsersSearch from "@/components/UsersSearch";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "Thesis",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    layout: {
      type: String,
      default: "view",
      validator: function (value) {
        return (
          [
            "view",
            "create",
            "update",
            "add_courses",
            "add_students",
            "add_teachers",
            "upload_file",
            "upload_file_proposal",
          ].indexOf(value) !== -1
        );
      },
    },
  },
  mixins: [Mixin],
  components: { CoursesSearch, UsersSearch },
  data() {
    return {
      file: "",
      thesis: {
        id: null,
        code: null,
        status: null,
        howManyStudentsAllow: 1,
        typeofthesis: 0,
        titleEl: "",
        abstractEl: "",
        titleEn: "",
        abstractEn: "",
        file: "",
      },      
      teacher1: null,
      courses: [],
      coursesArr: [],
      students: [],
      studentsArr: [],
      teachers: [],
      teachersArr: [],
      uploadFile: { file: null, filename: null },
      result: null,
      grades: null,
    };
  },
  computed: {
    isNew() {
      return this.id === 0;
    },
    isTeacher1() {
      if (
        !this.isNew &&
        this.result !== null &&
        typeof this.result.teacher1 !== "undefined" &&
        typeof this.user.id !== "undefined"
      ) {
        return parseInt(this.result.teacher1) === this.user.id;
      }
      return false;
    },
    isStudentOfThisThesis() {
      if (
        !this.isNew &&
        this.result !== null &&
        typeof this.user.id !== "undefined"
      ) {
        return this.studentsArr.indexOf(this.user.id) !== -1;
      }
      return false;
    },
    isTeacherOfThisThesis() {
      if (
        !this.isNew &&
        this.result !== null &&
        typeof this.user.id !== "undefined"
      ) {
        return this.teachersArr.indexOf(this.user.id) !== -1;
      }
      return false;
    },
    isInvalid() {
      return !this.thesis.id && !this.isNew && this.result !== null;
    },
    canUpdateThesis() {
      return (
        (this.isTeacher1 &&
          this.thesis.status >= 1 &&
          this.thesis.status <= 1) ||
        (this.isAdmin && this.thesis.status >= 1 && this.thesis.status <= 5)
      );
    },
    canDeleteThesis() {
      return (
        (this.isTeacher1 && this.thesis.status == 1) ||
        (this.isAdmin && this.thesis.status >= 1 && this.thesis.status <= 5)
      );
    },
    canUpdateThesisCourses() {
      return (
        (this.isTeacher1 && this.thesis.status == 1) ||
        (this.isAdmin && this.thesis.status >= 1 && this.thesis.status <= 5)
      );
    },
    canUpdateThesisStudents() {
      return (
        (this.isTeacher1 &&
          this.thesis.status >= 1 &&
          this.thesis.status <= 1) ||
        (this.isAdmin && this.thesis.status >= 1 && this.thesis.status <= 3)
      );
    },
    canUpdateThesisTeachers() {
      return this.isAdmin && this.thesis.status >= 4 && this.thesis.status <= 5;
    },
    canUploadFile() {
      return (
        this.isStudent &&
        this.thesis.status >= 2 &&
        this.thesis.status <= 5 &&
        this.thesis.lockedfile == 0 &&
        this.isStudentOfThisThesis
      );
      //return this.isStudent && this.thesis.status == 2 && this.isStudentOfThisThesis;
    },
    canUploadFileProposal() {      
      return (
         this.isStudent &&
         this.thesis.status >= 2 &&
         this.thesis.status <= 5 &&
         this.thesis.lockedfileproposal == 0 &&
         this.studentBachelorOrMaster >= 4 &&
         this.isStudentOfThisThesis
      );
      //return this.isStudent && this.thesis.status == 2 && this.isStudentOfThisThesis;
    },
    canRequestApproval() {
      return (
        this.isStudent &&
        this.thesis.status == 2 &&
        this.isStudentOfThisThesis &&
        this.thesis.file
      );
    },
    canDownloadVevaiosi() {
      return (
        this.isStudent &&
        //        this.thesis.status == 2 &&
        this.isStudentOfThisThesis
      );
    },
    thesisFormIsReady() {
      return (
        this.thesis.titleEl.length >=
          this.settings.thesis.characterMinTitleEl &&
        this.thesis.titleEl.length <=
          this.settings.thesis.characterMaxTitleEl &&
        this.thesis.abstractEl.length >=
          this.settings.thesis.characterMinAbstractEl &&
        this.thesis.abstractEl.length <=
          this.settings.thesis.characterMaxAbstractEl &&
        this.thesis.titleEn.length >=
          this.settings.thesis.characterMinTitleEn &&
        this.thesis.titleEn.length <=
          this.settings.thesis.characterMaxTitleEn &&
        this.thesis.abstractEn.length >=
          this.settings.thesis.characterMinAbstractEn &&
        this.thesis.abstractEn.length <=
          this.settings.thesis.characterMaxAbstractEn
      );
    },
    studentFormIsReady() {
      return (
        this.students.length <= this.thesis.howManyStudentsAllow &&
        this.students.length >= 0
      );
    },
    courseFormIsReady() {
      return this.courses.length >= 0;
    },
    teacherFormIsReady() {
      return (
        this.teachers.length <= this.settings.thesis.teachersThatGrade &&
        this.teachers.length >= 0
      );
    },
    uploadFileFormIsReady() {
      return (
        this.uploadFile !== null && typeof this.uploadFile.file !== "undefined"
      );
    },
    __watcher_thesis_refresh() {
      return this.id + "|" + this.layout;
    },
  },
  watch: {
    __watcher_thesis_refresh(newValue, oldValue) {
      const [oldId, oldLayout] = oldValue.split("|");
      const [newId, newLayout] = newValue.split("|");
      if (
        (newId !== oldId && newId !== 0) ||
        (newLayout !== oldLayout && newLayout !== "create")
      ) {
        this.getThesis(newId);
      }
    },
  },
  methods: {
    handleFileUpload() {
      this.uploadFile.file = this.$refs.file.files[0];
      this.uploadFile.filename = this.uploadFile.file.name;
    },
    approveThesisForExam(thesisid, approveoption) {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (r !== true) {
        return;
      }
      this.$store
        .dispatch("http_approve_thesis_for_exam", {
          thesisid: parseInt(thesisid),
          approveoption: parseInt(approveoption),
        })
        .then(() => {
          setTimeout(() => {
            this.ReloadPage();
          }, 500);
        })
        .catch((e) => {
          alert(e.bodyText);
          console.error(e);
        });
    },
    uploadThesisFile(event) {
      if (
        this.uploadFile === null ||
        typeof this.uploadFile.file === "undefined"
      ) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      let formData = new FormData();
      formData.append("file", this.uploadFile.file);
      formData.append("thesisid", this.thesis.id);
      this.$store
        .dispatch("http_send_thesis_file", {
          formData,
        })
        .then(() => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_FILE_UPLOADED"),
            5000
          );
          setTimeout(() => {
            this.goToView(this.thesis.id);
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    uploadThesisFileProposal(event) {
      if (
        this.uploadFile === null ||
        typeof this.uploadFile.file === "undefined"
      ) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      let formData = new FormData();
      formData.append("file", this.uploadFile.file);
      formData.append("thesisid", this.thesis.id);
      this.$store
        .dispatch("http_send_thesis_file_proposal", {
          formData,
        })
        .then(() => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_FILE_UPLOADED"),
            5000
          );
          setTimeout(() => {
            this.goToView(this.thesis.id);
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    addCourse(payload) {
      let found = false;
      for (let i = 0; i < this.courses.length; i++) {
        if (this.courses[i].id == payload.id) found = true;
      }
      if (!found) {
        this.courses.push({
          id: parseInt(payload.id),
          code: String(payload.code).trim(),
          name: String(payload.name).trim(),
          kind: String(payload.kind).trim(),
          semester: String(payload.semester).trim(),
          group: String(payload.group).trim(),
        });
      }
    },
    removeCourse(index) {
      if (index >= this.courses.length || index < 0) {
        return;
      }
      this.courses.splice(index, 1);
    },
    addStudent(payload) {
      if (this.students.length >= this.thesis.howManyStudentsAllow) {
        alert(
          this.Translate("@_MAXIMUM_ALLOWED_SUDENTS").replace(
            "[|NUMBER|]",
            this.thesis.howManyStudentsAllow
          )
        );
        return;
      }
      this.students.push({
        id: parseInt(payload.id),
        am: String(payload.am).trim(),
        name: String(payload.name).trim(),
        email: String(payload.email).trim(),
      });
    },
    removeStudent(index) {
      if (index >= this.students.length || index < 0) {
        return;
      }
      this.students.splice(index, 1);
    },
    addTeacher(payload) {
      if (this.teachers.length >= this.thesis.howManyTeachersAllow) {
        alert(
          this.Translate("@_MAXIMUM_ALLOWED_TEACHERS").replace(
            "[|NUMBER|]",
            this.thesis.howManyTeachersAllow
          )
        );
        return;
      }
      this.teachers.push({
        id: parseInt(payload.id),
        name: String(payload.name).trim(),
        email: String(payload.email).trim(),
      });
    },
    removeTeacher(index) {
      if (index >= this.teachers.length || index < 0) {
        return;
      }
      this.teachers.splice(index, 1);
    },
    getGrade(studentId) {
      let sum = 0;
      if (this.grades) {
        for (let i = 0; i < this.grades.length; i++) {
          if (this.grades[i].student_id == studentId) {
            sum = sum + parseFloat(this.grades[i].calculatedgrade) / 3;
          }
        }
      }
      return sum.toFixed(2);
    },
    goBack() {
      this.$router.go(-1);
      this.$forceUpdate();
    },
    sendRequestForExamApproval(event) {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (r !== true || !this.thesisFormIsReady) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      this.$store
        .dispatch("http_send_response_for_exam_approval", {
          thesisid: parseInt(this.id),
        })
        .then(() => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_THESIS_REQUEST_APPROVAL_SEND"),
            5000
          );
          setTimeout(() => {
            this.ReloadPage();
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert("alert-danger", e.bodyText, 5000);
          console.error(e);
        });
    },
    downloadThesis(event) {
      event.target.disabled = true;
      event.target.classList.add("running");
      this.$store
        .dispatch("http_download_thesis", {
          thesisid: parseInt(this.id),
          file: this.thesis.file,
        })
        .then(() => {
          event.target.disabled = false;
          event.target.classList.remove("running");
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    downloadThesisProposal(event) {
      event.target.disabled = true;
      event.target.classList.add("running");
      this.$store
        .dispatch("http_download_thesis_proposal", {
          thesisid: parseInt(this.id),
          file: this.thesis.fileproposal,
        })
        .then(() => {
          event.target.disabled = false;
          event.target.classList.remove("running");
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    unlockFileThesis(lockoption, event) {
      event.target.disabled = true;
      event.target.classList.add("running");
      this.$store
        .dispatch("http_unlock_file_thesis", {
          thesisid: parseInt(this.id),
          lockoption: parseInt(lockoption),
        })
        .then(() => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          location.reload();
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    goToView(InThesisId) {
      this.$router
        .push({
          name: "thesis_view",
          params: { id: parseInt(InThesisId) },
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getThesis(InId) {
      this.$store
        .dispatch("http_get_thesis", {
          id: parseInt(InId),
        })
        .then((resp) => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          if (resp.length > 0) {
            this.file = "";
            this.thesis = {
              id: null,
              code: null,
              status: null,
              howManyStudentsAllow: null,
              typeofthesis: null,
              titleEl: "",
              abstractEl: "",
              titleEn: "",
              abstractEn: "",
              file: "",
            };
            this.file = null;
            this.courses = [];
            this.coursesArr = [];
            this.students = [];
            this.studentsArr = [];
            this.teachers = [];
            this.teachersArr = [];
            this.uploadFile = { file: null, filename: null };
            this.result = null;

            this.result = resp[0];
            this.thesis.created_at = this.result.created_at;
            this.thesis.contract_date = this.result.contract_date;
            this.thesis.presentation_date = this.result.presentation_date;
            this.thesis.graded_date = this.result.graded_date;
            this.thesis.deadline_date = this.result.deadline_date;

            this.thesis.active = parseInt(this.result.active);
            this.thesis.id = parseInt(this.result.id);
            this.thesis.code = parseInt(this.result.code);
            this.thesis.status = parseInt(this.result.status);
            this.thesis.statustext = this.result.statustext;
            this.thesis.file = this.result.file;
            this.thesis.lockedfile = this.result.lockedfile;
            this.thesis.fileproposal = this.result.fileproposal;
            this.thesis.lockedfileproposal = this.result.lockedfileproposal;
            this.thesis.howManyStudentsAllow = parseInt(
              this.result.howmanystudentsallow
            );
            this.thesis.typeofthesis = parseInt(this.result.typeofthesis);

            this.thesis.totalgrade = this.result.totalgrade;
            this.thesis.titleEl = String(this.result.titleEl).trim();
            this.thesis.titleEn = String(this.result.titleEn).trim();
            this.thesis.abstractEl = this.result.abstractEl;
            this.thesis.abstractEn = this.result.abstractEn;
            if (
              this.result.courses !== null &&
              Array.isArray(this.result.courses) &&
              this.result.courses.length > 0
            ) {
              for (var index = 0; index < this.result.courses.length; index++) {
                this.courses.push({
                  id: parseInt(this.result.courses[index].id),
                  code: String(this.result.courses[index].code).trim(),
                  name: String(this.result.courses[index].name).trim(),
                  kind: String(this.result.courses[index].kind).trim(),
                  semester: String(this.result.courses[index].semester).trim(),
                  group: String(this.result.courses[index].group).trim(),
                });
                this.coursesArr.push(parseInt(this.result.courses[index]));
              }
            }
            if (this.result.student1 !== null) {
              this.students.push({
                id: parseInt(this.result.student1),
                am: String(this.result.student1_am).trim(),
                name: String(this.result.student1_name).trim(),
                email: String(this.result.student1_email).trim(),
              });
              this.studentsArr.push(parseInt(this.result.student1));
            }
            if (this.result.student2 !== null) {
              this.students.push({
                id: parseInt(this.result.student2),
                am: String(this.result.student2_am).trim(),
                name: String(this.result.student2_name).trim(),
                email: String(this.result.student2_email).trim(),
              });
              this.studentsArr.push(parseInt(this.result.student2));
            }
            if (this.result.teacher1 !== null) {
              this.teacher1 = {
                id: parseInt(this.result.teacher1),
                name: String(this.result.teacher1_name).trim(),
                email: String(this.result.teacher1_email).trim(),
              };
            }
            if (this.result.teacher2 !== null) {
              this.teachers.push({
                id: parseInt(this.result.teacher2),
                name: String(this.result.teacher2_name).trim(),
                email: String(this.result.teacher2_email).trim(),
              });
              this.teachersArr.push(parseInt(this.result.teacher2));
            }
            if (this.result.teacher3 !== null) {
              this.teachers.push({
                id: parseInt(this.result.teacher3),
                name: String(this.result.teacher3_name).trim(),
                email: String(this.result.teacher3_email).trim(),
              });
              this.teachersArr.push(parseInt(this.result.teacher3));
            }
            if (this.thesis.status == 6) {
              this.getGrades(this.id);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    createThesis(event) {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (r !== true || !this.thesisFormIsReady) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      this.$store
        .dispatch("http_post_thesis", {
          howManyStudentsAllow: parseInt(this.thesis.howManyStudentsAllow),
          typeofthesis: parseInt(this.thesis.typeofthesis),
          titleEl: String(this.thesis.titleEl).trim(),
          titleEn: String(this.thesis.titleEn).trim(),
          abstractEl: String(this.thesis.abstractEl).trim(),
          abstractEn: String(this.thesis.abstractEn).trim(),
        })
        .then((resp) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_THESIS_CREATED"),
            5000
          );
          setTimeout(() => {
            this.goToView(resp.thesisId);
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    updateThesis(event) {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (r !== true || !this.thesisFormIsReady || !this.canUpdateThesis) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      this.$store
        .dispatch("http_put_thesis", {
          id: parseInt(this.thesis.id),
          howManyStudentsAllow: parseInt(this.thesis.howManyStudentsAllow),
          typeofthesis: parseInt(this.thesis.typeofthesis),
          titleEl: String(this.thesis.titleEl).trim(),
          titleEn: String(this.thesis.titleEn).trim(),
          abstractEl: String(this.thesis.abstractEl).trim(),
          abstractEn: String(this.thesis.abstractEn).trim(),
        })
        .then((resp) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_THESIS_UPDATED"),
            5000
          );
          setTimeout(() => {
            this.goToView(resp.thesisId);
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    deleteThesis(event) {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (r !== true || !this.canDeleteThesis) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      this.$store
        .dispatch("http_delete_thesis", {
          id: parseInt(this.thesis.id),
        })
        .then(() => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_THESIS_DELETED"),
            5000
          );
          setTimeout(() => {
            this.$router.push({ name: "theses" }).catch((err) => {
              console.log(err);
            });
            //this.goBack();
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_THESIS_DELETED"),
            5000
          );
          console.error(e);
        });
    },
    updateThesisCourses(event) {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (
        r !== true ||
        !this.courseFormIsReady ||
        !this.canUpdateThesisCourses
      ) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      let tmpCourses = [];
      for (let index = 0; index < this.courses.length; index++) {
        let tmpStudent = this.courses[index];
        tmpCourses.push(parseInt(tmpStudent.id));
      }
      this.$store
        .dispatch("http_put_thesis_add_courses", {
          id: parseInt(this.thesis.id),
          courses: tmpCourses,
        })
        .then((resp) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_THESIS_UPDATED"),
            5000
          );
          this.status = resp.status; //θέλω να αλλάζει αυτόματα
          setTimeout(() => {
            this.goToView(resp.thesisid);
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    updateThesisStudents(event) {
      var r = confirm(
        "O φοιτητής του Προπτυχιακού Προγράμματος Σπουδών για να αναλάβει μια Πτυχιακή ή Διπλωματική εργασία πρέπει να έχει πάνω από 160 ή 210 Δ.Μ. αντίστοιχα. O φοιτητής του Προγράμματος Μεταπτυχιακών Σπουδών (Π.Μ.Σ) για να αναλάβει Διπλωματική εργασία πρέπει να ικανοποιούνται οι προϋποθέσεις σύμφωνα με τον Κανονισμό Διπλωματικών Εργασιών του Π.Μ.Σ. Κατα την αποδοχή ανάληψης ο Επιβλέπων συμφωνεί και έχει εξετάσει ότι ο φοιτητής ικανοποιεί τις προϋποθέσεις. Θέλετε να προχωρήσετε στην Οριστικοποίηση;"
      );
      if (
        r !== true ||
        !this.studentFormIsReady ||
        !this.canUpdateThesisStudents
      ) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      let tmpStudents = [];
      for (let index = 0; index < this.students.length; index++) {
        let tmpStudent = this.students[index];
        tmpStudents.push(parseInt(tmpStudent.id));
      }
      this.$store
        .dispatch("http_put_thesis_add_students", {
          id: parseInt(this.thesis.id),
          students: tmpStudents,
        })
        .then((resp) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_THESIS_UPDATED"),
            5000
          );
          this.status = resp.status; //θέλω να αλλάζει αυτόματα
          setTimeout(() => {
            this.goToView(resp.thesisid);
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert("alert-danger", e.bodyText, 5000);
          console.error(e);
        });
    },
    updateThesisTeachers(event) {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (
        r !== true ||
        !this.teacherFormIsReady ||
        !this.canUpdateThesisTeachers
      ) {
        return;
      }
      event.target.disabled = true;
      event.target.classList.add("running");
      let tmpTeachers = [];
      for (let index = 0; index < this.teachers.length; index++) {
        let tmpTeacher = this.teachers[index];
        tmpTeachers.push(parseInt(tmpTeacher.id));
      }
      this.$store
        .dispatch("http_put_thesis_add_teachers", {
          id: parseInt(this.thesis.id),
          teachers: tmpTeachers,
        })
        .then(() => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-success",
            this.Translate("@_THESIS_UPDATED"),
            5000
          );
          setTimeout(() => {
            this.goBack();
          }, 500);
        })
        .catch((e) => {
          event.target.disabled = false;
          event.target.classList.remove("running");
          this.ShowAlert(
            "alert-danger",
            this.Translate("@_GENERAL_ERROR"),
            5000
          );
          console.error(e);
        });
    },
    downloadGrades(studentName, studentAm, studentId) {
      //http://pdfmake.org/playground.html
      var docDefinition = {
        content: [
          {
            image:
              "data:image/png;base64,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",
            width: 200,
            height: 50,
            fontSize: 12,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            text: "ΑΛΕΞΑΝΔΡΕΙΑ ΠΑΝΕΠΙΣΤΗΜΙΟΥΠΟΛΗ",
            fontSize: 12,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            text: "ΣΧΟΛΗ ΜΗΧΑΝΙΚΩΝ",
            fontSize: 12,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            text: "ΤΜΗΜΑ ΜΗΧΑΝΙΚΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ",
            fontSize: 12,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            text:
              "Δ/νση: ΤΘ: 141, 57400 Σίνδος, Θεσσαλονίκη, Τηλ: 2310 013621, Fax: 2310 791132",
            fontSize: 9,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 535,
                y2: 5,
                lineWidth: 0.5,
              },
            ],
          },
          {
            text: "ΒΕΒΑΙΩΣΗ ΕΞΕΤΑΣΗΣ ΠΤΥΧΙΑΚΗΣ/ΔΙΠΛΩΜΑΤΙΚΗΣ ΕΡΓΑΣΙΑΣ",
            bold: true,
            fontSize: 11,
            alignment: "center",
            margin: [0, 20, 0, 20],
          },
          {
            text:
              "Ο/Η φοιτητής/φοιτήτρια του τμήματος Μηχανικών Πληροφορικής και Ηλεκτρονικών Συστημάτων του ΔΙ.ΠΑ.Ε. " +
              studentName +
              " με Α.Μ. " +
              studentAm +
              " εξετάστηκε στη πτυχιακή/διπλωματική εργασία  στις " +
              this.thesis.graded_date +
              " με θέμα <<" +
              this.thesis.titleEl +
              ">> (κωδικός: " +
              this.thesis.code +
              ") και επιβλέποντα τον/την κ. " +
              this.teacher1.name +
              " ενώπιον τριμελούς εξεταστικής επιτροπής.",
            lineHeight: 2,
            fontSize: 11,
            alignment: "left",
            margin: [0, 0, 0, 10],
          },
          {
            text:
              "Bαθμός της πτυχιακής/διπλωματικής εργασίας του Φοιτητή: " +
              this.getGrade(studentId),
            fontSize: 12,
            alignment: "left",
            margin: [0, 0, 0, 10],
          },
          {
            text:
              "Γενικός βαθμός της πτυχιακής/διπλωματικής εργασίας: " +
              this.thesis.totalgrade,
            fontSize: 12,
            alignment: "left",
            margin: [0, 0, 0, 10],
          },
          {
            text: "Το παρόν δεν αποτελεί επίσημο έγγραφο",
            fontSize: 12,
            alignment: "left",
            margin: [0, 0, 0, 30],
          },
        ],
        //https://pdfmake.github.io/docs/document-definition-object/styling/
        styles: {
          header: {
            fontSize: 14,
            alignment: "center",
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 11,
            bold: false,
            margin: [0, 10, 0, 5],
          },
          tableTheses: {
            fontSize: 10,
            alignment: "center",
            margin: [0, 5, 0, 15],
          },
        },
      };

      pdfMake.tableLayouts = {
        myTableLayout: {
          bold: function (i) {
            if (i === 0) {
              return true;
            }
          },
          fillColor: function (i) {
            if (i === 0) {
              return "yellow";
            }
            if (i % 2 === 0) {
              return "#AAAAAA";
            }
          },
        },
      };
      //pdfMake.createPdf(docDefinition).download();
      pdfMake.createPdf(docDefinition).open({}, window);
    },
    getGrades(InId) {
      this.$store
        .dispatch("http_get_grades", {
          id: parseInt(InId),
        })
        .then((resp) => {
          this.grades = resp;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
  created() {
    if (this.layout !== "create") {
      this.getThesis(this.id);
    }
  },
};
</script>

<style scoped></style>
